import BusinessQuoteForm from '@/components/forms/BusinessQuoteForm/BusinessQuoteForm';

interface BusinessQuoteFormBlockProps {
	data: any;
	blockId: string;
}

export default function BusinessQuoteFormBlock({ blockId, data }: BusinessQuoteFormBlockProps) {
	const showLogo = data?.show_logo ?? true;
	const showToggle = data?.show_toggle ?? true;

	return (
		<section id={blockId} className="pb-16 md:pb-24 pt-0 bg-gray-50">
			<BusinessQuoteForm showLogo={showLogo} showToggle={showToggle} />
		</section>
	);
}
